
import { defineComponent, onMounted, ref, Ref, getCurrentInstance } from 'vue';
import { roundingNum } from '@/common/utils';

export default defineComponent({
    components: {},
    props: {},
    setup(props, ctx) {
        const { proxy } = getCurrentInstance() as { proxy: Record<string, any> };
        const searchword = ref('');
        const likes = ref(0);
        const pins = ref(0);
        const kwaiid = ref('');
        const relatedWords: Ref<string[]> = ref([]);
        const showThis = ref(false); // 展示与否在内部判断，避免代码混在discover里面

        // www.kwai.com/discover/ + &{like} & {pins} pins de &{search_word} - By Kwai &{kwai_id} - related to &{search_word_relate}
        const parseLocation = () => {
            const currentPath = decodeURIComponent(window?.location?.pathname);
            showThis.value = /pins(-| )de/.test(currentPath);
            if (!showThis.value) {
                return;
            }
            const currentPathReplace = currentPath.replace(/(-)/g, ' ').replace(/(pins de)|(BY Kwai)|(related TO)/g, '');
            const expandWords = currentPathReplace.split('&');
            likes.value = expandWords.length > 1 ? parseInt(expandWords[1]) : 0; // 第一个为/discover/， 第二个开始为使用数据
            pins.value = expandWords.length > 2 ? parseInt(expandWords[2]) : 0;
            searchword.value = expandWords.length > 3 ? expandWords[3] : '';
            kwaiid.value = expandWords.length > 4 ? expandWords[4] : '';
            const relatedWordsStr = expandWords.length > 5 ? expandWords[5] : '';
            relatedWords.value = relatedWordsStr.split(',');
        };
        const gotoSearchWithRelated = (searchText: string) => {
            proxy.$router.push({ path: `/discover/${searchText}` });
        };

        onMounted(() => {
            parseLocation();
        });

        return {
            searchword,
            likes,
            pins,
            kwaiid,
            relatedWords,
            roundingNum,
            showThis,
            gotoSearchWithRelated,
        };
    },
});
